import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { Component_MAWP } from "../../services/component_mawp";
import { LTA_module } from "../../services/lta_module";
import { LTAP_module } from "../../services/ltap_module";
import { Laminations_module } from "../../services/laminations_module";
import { CalcTemplate } from "../../services/calctemplate";
import { BehaviorSubject, min, Subject, Subscription } from "rxjs";
import { Pitting_module } from "../../services/pitting_module";
import { GML_module } from "../../services/gml_module";
import { BlisterHIC_module } from "../../services/blisterHIC_module";
import { Dent_Module } from "../../services/dent_module";
import { Crack_Module } from "../../services/crack_module";
import { Utility } from "../../services/utility";
import { WarningModalComponent } from "../warning-modal/warning-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ComponentInformationComponent } from "./component-information/component-information.component";
import { FormControlsEventProxyService } from "../../services/formcontrols_eventproxy_service";
import { Component_MAEP } from "../../services/component_maep";
import { Component_MFH } from "../../services/component_mfh";
import { MFHComponent } from "../mfh/mfh.component";
import { ComponentEventService } from "../../services/component_event.service";

@Component({
    selector: "inspection-data",
    templateUrl: "inspection-data.component.html",
    standalone: false
})
export class InspectionDataComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() MAWP_result = "";
  @Input() MAEP_result = "";
  @Input() radiobuttonDI: string="";
  @Input() isMfhMode: boolean = false;
  @Input() inspectionDataCalc: Subject<boolean>;
  @Output() inspectionDataResult: EventEmitter<any> = new EventEmitter();
  @Output("nextStep") nextStep: EventEmitter<any> = new EventEmitter();
  componentInformationValidation: Subject<boolean> = new Subject<boolean>();

  inspectionDataFormGroup: FormGroup;

  @ViewChild(ComponentInformationComponent)
  childComponentInformationComponent: ComponentInformationComponent;

  inspectionDataCalculateCallValidationsInPitting: Subject<boolean> =
    new Subject();

  public validation_list = [];
  public validation_list_ComponentInformation = [];
  private contextResetSubscription: Subscription;

  // below 4 properties are only used/changed in LMLProfileData assesment flow
  @Input() lmlProfileData_intnum_t_pt: number;
  @Output() lmlProfileData_intnum_t_ptChange = new EventEmitter<number>();
  @Input() lmlProfileData_sngGrid_spacing: number;
  @Output() lmlProfileData_sngGrid_spacingChange = new EventEmitter<number>();
  @Input() lmlProfileData_disable_intnum_t_pt: Subject<boolean>;

  public component_mawp = Component_MAWP;
  public component_maep = Component_MAEP;
  public utility_service = Utility;

  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;

  // Declare two input values and one output value
  intUnit_select: number = parseInt(localStorage.getItem("unitType")) || 0;
  comboBox1_DI_index: number = 1; //base-metal default

  summary: string;
  result: string;
  intUnit: number;

  div_for_comboBox2_DI_Equip_Hyd_visible: boolean;
  div_for_comboBox3_DI_Equip_Hyd_visible: boolean;
  requirementsForLaminationApproved: boolean;

  comboBox2_DI_Enabled: boolean = true;
  textBox4_DI_Enabled: boolean = true;

  basicValidationLabel: string =
    "Following inputs have invalid information.";
  pittingDisplayWarningModal: boolean;

  private readonly hmlBelowHcMessage =
    "Axial distance H_ml cannot be less than H_c.";

  private radioButton_DI: FormControl = new FormControl({
    value: "radioButton1_DI_enabled",
    disabled: false,
  });

  getComboBox1_DI_Equip_Hyd_formControl(): FormControl {
    return this.inspectionDataFormGroup.get(
      "comboBox1_DI_Equip_Hyd"
    ) as FormControl;
  }

  getComboBox2_DI_Equip_Hyd_formControl(): FormControl {
    return this.inspectionDataFormGroup.get(
      "comboBox2_DI_Equip_Hyd"
    ) as FormControl;
  }

  getComboBox3_DI_Equip_Hyd_formControl(): FormControl {
    return this.inspectionDataFormGroup.get(
      "comboBox3_DI_Equip_Hyd"
    ) as FormControl;
  }

  getTextBox1_DI_formControl(): FormControl {
    return this.inspectionDataFormGroup.get("textBox1_DI") as FormControl;
  }

  getComboBox1_DI_formControl(): FormControl {
    return this.inspectionDataFormGroup.get("comboBox1_DI") as FormControl;
  }

  getTextBox1_DI_EquipInfo_formControl(): FormControl {
    return this.inspectionDataFormGroup.get(
      "textBox1_DI_EquipInfo"
    ) as FormControl;
  }

  fieldSetVisible(): boolean {
    return (
      Component_MAWP.strD_class != "Lamination" ||
      this.requirementsForLaminationApproved
    );
  }

  // intEquip 8 identifies an atmospheric storage tank shell course.
  isTankComponent(): boolean {
    return (
      this.isMfhMode ||
      Component_MFH.intEquip === 8 ||
      Component_MAWP.intEquip === 8
    );
  }

  componentData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  updateComponentData(grayedOut: boolean) {
    this.componentData.next(grayedOut);
  }

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private formControlsEventProxyService: FormControlsEventProxyService,
    private componentEventService: ComponentEventService
  ) {
    this.div_for_comboBox2_DI_Equip_Hyd_visible = false;
    this.div_for_comboBox3_DI_Equip_Hyd_visible = false;
    this.requirementsForLaminationApproved = false;

    switch (Component_MAWP.strD_iclass) {
      case 0: //GML
        this.inspectionDataFormGroup = this._formBuilder.group({
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],       // non-MFH GML / LTA: textBox3 field
          textBox3_DI_sngH_f: [""],                    // MFH mode: H_f (used by mfh-shell-inspection-fields child component)
          textBox7_DI_sngfcaML: ["", Validators.required],           // MFH mode: FCAml (used by mfh-shell-inspection-fields child component)  
          textBox3_DI_sngH_ml: ["", Validators.required],                    // MFH mode: H_ml (used by mfh-shell-inspection-fields child component)
          textBox8_DI: [""],
          textBox7_DI_sngHf: [""],
          textBox4_DI: ["", Validators.required],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          radioButton_DI: this.radioButton_DI,
        });
        this.inspectionDataFormGroup.controls.textBox6_DI_snggr.disable();
        break;
      case 5: //BlisterHIC
        this.inspectionDataFormGroup = this._formBuilder.group({
          comboBox1_DI: ["No", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          textBox7_DI: ["", Validators.required],
          comboBox2_DI_BlisterHIC: ["", Validators.required],
          comboBox3_DI: ["", Validators.required],
        });
        break;
      case 6: //Crack
        this.inspectionDataFormGroup = this._formBuilder.group({
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          comboBox1_DI: ["", Validators.required],
          comboBox2_DI: [
            { value: "", disabled: !this.comboBox2_DI_Enabled },
            Validators.required,
          ],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          comboBox3_DI: ["", Validators.required],
        });
        break;
      case 7: // Dent
        this.inspectionDataFormGroup = this._formBuilder.group({
          comboBox1_DI: ["", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox1_DI_EquipInfo: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
        });
        break;
      case 8: // DentGouge
        this.inspectionDataFormGroup = this._formBuilder.group({
          comboBox1_DI: ["", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: [
            { value: "", disabled: true },
            Validators.required,
          ],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          textBox7_DI_sngHf: ["", Validators.required],
          textBox8_DI: ["", Validators.required],
          textBox9_DI: ["", Validators.required],
          textBox1_DI_EquipInfo: [
            { value: "", disabled: true },
            Validators.required,
          ],
          radioButton_DI: this.radioButton_DI,
        });
        let textBox1_DI_EquipInfo_formControl = this.getTextBox1_DI_EquipInfo_formControl();
        textBox1_DI_EquipInfo_formControl.disable();
        break;
      case 9: //Laminations
        this.inspectionDataFormGroup = this._formBuilder.group({
          comboBox1_DI_Equip_Hyd: ["", Validators.required],
          comboBox2_DI_Equip_Hyd: ["", Validators.required],
          comboBox3_DI_Equip_Hyd: ["", Validators.required],
          comboBox1_DI: ["No", Validators.required],
          comboBox2_DI: ["", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          textBox7_DI_sngHf: ["", Validators.required],
          radioButton_DI: this.radioButton_DI,
        });
        break;
      case 2: // LTAP - Local Metal Loss Profile Data
        this.inspectionDataFormGroup = this._formBuilder.group({
          // Existing generic controls for backward compatibility
          comboBox1_DI: ["", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          textBox3_DI_sngH_f: [""],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          textBox5_DI_external: [null, [Validators.required]],
          textBox6_DI_external: [null, [Validators.required]],
          textBox7_DI: ["", Validators.required],
          textBox7_DI_external: [null, [Validators.required]],
          textBox8_DI_external: [null, [Validators.required]],
          textBox5_DI_sngLmsd: ["", Validators.required],
          radioButton_DI: this.radioButton_DI,
          // New LTAP-specific controls for tanks-ltap-inspection-fields component (MFH mode)
          ltap_2s2cBox: [""],
          ltap_metalLossLength_s: [""],
          ltap_numMeasurements: ["", Validators.required],
          ltap_fcaml: [""],
          ltap_circLength_c: [""],
          ltap_hml: [""],
          ltap_lmsd: [""],
          ltap_grooveRadius_gr: [""],
        });
        this.inspectionDataFormGroup.controls.textBox6_DI_snggr.disable();
        break;
      default:
        this.inspectionDataFormGroup = this._formBuilder.group({
          comboBox1_DI: ["", Validators.required],
          textBox1_DI: ["", Validators.required],
          textBox2_DI: ["", Validators.required],
          textBox3_DI: ["", Validators.required],
          textBox3_DI_sngH_f: [""],
          textBox4_DI: [
            { value: "", disabled: !this.textBox4_DI_Enabled },
            Validators.required,
          ],
          textBox5_DI: ["", Validators.required],
          textBox6_DI_snggr: ["", Validators.required],
          textBox5_DI_external: [null, [Validators.required]],
          textBox6_DI_external: [null, [Validators.required]],
          textBox7_DI: ["", Validators.required],
          textBox7_DI_external: [null, [Validators.required]],
          textBox8_DI_external: [null, [Validators.required]],
          textBox5_DI_sngLmsd: ["", Validators.required],
          radioButton_DI: this.radioButton_DI,
        });
        this.inspectionDataFormGroup.controls.textBox6_DI_snggr.disable();
        break;
    }
  }

  ngOnInit(): void {
    this.setDefaults();
    this.intUnit = parseInt(localStorage.getItem("unitType")) || 0; // 0 - US, 1 - SI
    Component_MAWP.intUnit_select = this.intUnit;
    const mfhHfFormControl = this.inspectionDataFormGroup.get("textBox3_DI_sngH_f");
    if (mfhHfFormControl && Number.isFinite(Number(Component_MFH.sngH_f)) && Number(Component_MFH.sngH_f) >= 0) {
      mfhHfFormControl.setValue(Component_MFH.sngH_f);
    }
    this.summary = "";
    this.result = "";
    this.inspectionDataCalc.subscribe((v) => {
      this.onPressPictureBox2_DI();
    });

    if (Component_MAWP.strD_iclass === 2) {
      this.lmlProfileData_disable_intnum_t_pt.subscribe((v) => {
        this.disable_lmlProfileData_intnum_t_pt();
      });
    }
    this.comboBox2_DI_Enabled = true;
    this.textBox4_DI_Enabled = true;

    if (Component_MAWP.strD_iclass !== 4)
      // Pitting has its own form controls in Pitting information component
      this.formControlsEventProxyService
        .getInspectionDataEventSubject()
        .subscribe((v) => {
          this.updateFormControlsAfterImport();
        });

    this.formControlsEventProxyService
      .getMfhShellCourseBottomHeightEventSubject()
      .subscribe(() => {
        this.updateHmlAgainstHcValidation();
      });

    this.contextResetSubscription =
      this.componentEventService.assessmentContextReset$.subscribe(() => {
        this.resetInspectionData();
      });
  }

  ngOnDestroy(): void {
    this.contextResetSubscription?.unsubscribe();
  }

  private resetInspectionData(): void {
    this.inspectionDataFormGroup.reset();
    this.inspectionDataFormGroup.markAsPristine();
    this.inspectionDataFormGroup.markAsUntouched();

    this.childComponentInformationComponent?.componentInformationFormGroup?.reset();

    this.validation_list = [];
    this.validation_list_ComponentInformation = [];
    this.summary = "";
    this.result = "";
    this.inspectionDataResult.emit("");

    this.setDefaults();
    this.cd.markForCheck();
  }

  ngAfterViewInit() {
    if ([8].includes(Component_MAWP.strD_iclass)) {
      // 6,
      this.inspectionDataFormGroup.addControl(
        "childComponentInformationForm",
        this.childComponentInformationComponent.componentInformationFormGroup
      );
      this.childComponentInformationComponent.componentInformationFormGroup.setParent(
        this.inspectionDataFormGroup
      );
    }
  }

  setDefaults() {
    LTA_module.intLTA_type = 0;
    switch (Component_MAWP.strD_iclass) {
      case 5: // BListerHIC
        // do nothing in BListerHIC
        break;
      case 6: // Crack
        this.onChangeComboBox2_DI("Parallel");
        break;
      case 7: // Dents
        // do nothing in Dents, Dents doesnt have ComboBox2 and RadioButton1
        break;
      case 8:
        this.onChangeRadioButton1_DI("radioButton1_DI_enabled");
        this.inspectionDataFormGroup.get("textBox6_DI_snggr")["enable"]();
        Dent_Module.intd_key = 0;
        break;
      case 9: // Laminations
        this.onChangeRadioButton1_DI("radioButton1_DI_enabled");
        break;
      default:
        this.onChangeRadioButton1_DI("radioButton1_DI_enabled");
        this.onChangeComboBox2_DI("Yes");
        break;
    }
  }

  onInput_lmlProfileData_intnum_t_pt(event: any) {
    if (Component_MAWP.strD_iclass === 2) {
      // Number of thickness measurements must be a whole number (no decimals).
      const rawValue: string = event.target.value ?? "";
      const integerValue = rawValue.replace(/[^\d]/g, "");
      if (integerValue !== rawValue) {
        event.target.value = integerValue;
      }
      this.lmlProfileData_intnum_t_pt = integerValue as unknown as number;
      this.lmlProfileData_intnum_t_ptChange.emit(
        this.lmlProfileData_intnum_t_pt
      );
    }
  }

  onInput_lmlProfileData_sngGrid_spacing(event: any) {
    if (Component_MAWP.strD_iclass === 2) {
      this.lmlProfileData_sngGrid_spacing = event.target.value;
      let textBox1_DI_formControl: FormControl =
        this.getTextBox1_DI_formControl();
      if (this.lmlProfileData_sngGrid_spacing.toString() === "0") {
        textBox1_DI_formControl.setValue("");
        textBox1_DI_formControl.disable(); // disable lmlProfileData_intnum_t_pt when gridSpacing is 0
      } else if (!textBox1_DI_formControl.enabled) {
        textBox1_DI_formControl.setValue("");
        textBox1_DI_formControl.enable();
      }

      this.lmlProfileData_sngGrid_spacingChange.emit(
        this.lmlProfileData_sngGrid_spacing
      );
    }
  }

  DentInPressurizedCondition(): boolean {
    if ([7, 8].indexOf(Component_MAWP.strD_iclass) !== -1) {
      let comboBox1_DIformControl = this.getComboBox1_DI_formControl();

      if (comboBox1_DIformControl.value === "Yes") return true;
      else if (comboBox1_DIformControl.value === "No") return false;

      return true;
    }
  }

  disable_lmlProfileData_intnum_t_pt() {
    let textBox1_DI_formControl: FormControl =
      this.getTextBox1_DI_formControl();
    textBox1_DI_formControl.disable();
  }

  onUpdateValidationsStatus(validationsStatusData: any) {
    this.validation_list = validationsStatusData.messagesValidationsList;

    if (validationsStatusData.displayWarningModal)
      this.pittingDisplayWarningModal = true;
    else this.pittingDisplayWarningModal = false;
  }

  openPittingWarningModal(): void {
    let pittingWarningMessage: string[] = [];
    pittingWarningMessage.push(
      "Pitting Corrosion is defined as localized regions of metal loss charecterized by a pit diameter on the order of the plate thickness or less and a pit depth that is less than the plate thickness."
    );
    pittingWarningMessage.push(
      "Pitting Corrosion Level 1 assessment is limited to widespread pitting."
    );

    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: { warningMessage: pittingWarningMessage, caption: "Alert", captionCenter: true, cancelButtonShow: false },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // "OK"
        Pitting_module.Pit_RSF_calc();
        this.result = Pitting_module.Pit_calc();
        this.nextStep.emit();
        this.inspectionDataResult.emit(this.result);
      } // back
    });
  }

  updateFormControlsAfterImport() {
    switch (Component_MAWP.strD_iclass) {
      case 0:
        GML_module.updateInspectionDataFormControls(
          this.inspectionDataFormGroup
        );
        break;
      case 1:
      case 2:
      case 3:
        LTA_module.updateInspectionDataFormControls(
          this.inspectionDataFormGroup
        );
        this.updateMfhLmlInspectionFormControls();
        this.updateMfhLtapInspectionFormControls();
        break;
      case 5:
        BlisterHIC_module.updateInspectionDataFormControls(this.inspectionDataFormGroup);
        break;
      case 6:
        Crack_Module.updateInspectionDataFormControls(this.inspectionDataFormGroup);
        break;
      case 7:
        Dent_Module.updateInspectionDataFormControlsForDent(this.inspectionDataFormGroup);
        break;
      case 8:
        Dent_Module.updateInspectionDataFormControlsForDentGouge(this.inspectionDataFormGroup);
        break;
      case 9:
        this.updateFormControlsForLaminations();
        break;
      default: //for other calculations
        break;
    }

    this.validation_list = [];
  }

  // MFH tank LML/Gouge imports carry their inspection values on Component_MFH
  // (snap_* and sngH_f) rather than LTA_module, so the generic LTA restore above
  // leaves the tank-only controls (tmm, s, H_ml, gr) empty. Repopulate them here.
  private updateMfhLmlInspectionFormControls(): void {
    if (!this.isTankComponent() || [1, 3].indexOf(Component_MAWP.strD_iclass) === -1) {
      return;
    }

    const setControlValue = (name: string, value: number): void => {
      const control = this.inspectionDataFormGroup.get(name);
      if (control && Number.isFinite(Number(value))) {
        control.setValue(Number(value).toString());
      }
    };

    setControlValue("textBox1_DI", Component_MFH.snap_tmm); // Minimum measured thickness, tmm
    setControlValue("textBox3_DI", Component_MFH.snap_sLong); // Length of metal loss, s
    setControlValue("textBox7_DI", Component_MFH.sngH_f); // Height to lower flaw edge, H_ml
    if (Number.isFinite(Number(Component_MFH.snap_gr))) {
      setControlValue("textBox6_DI_snggr", Component_MFH.snap_gr); // Groove radius, gr
    }
  }

  // LMLPD tank imports (strD_iclass === 2) render the tanks-ltap-inspection-fields
  // child, whose ltap_* controls are not touched by the generic LTAP restore above.
  private updateMfhLtapInspectionFormControls(): void {
    if (!this.isTankComponent() || Component_MAWP.strD_iclass !== 2) {
      return;
    }

    const setControlValue = (name: string, value: number): void => {
      const control = this.inspectionDataFormGroup.get(name);
      if (control && Number.isFinite(Number(value)) && Number(value) !== -1) {
        control.setValue(Number(value).toString());
      }
    };

    setControlValue("ltap_numMeasurements", LTAP_module.intnum_t_pt); // n
    setControlValue("ltap_metalLossLength_s", LTAP_module.sngGrid_spacing); // sp
    setControlValue("ltap_fcaml", CalcTemplate.sngFCAml); // FCAml
    setControlValue("ltap_lmsd", CalcTemplate.sngLmsd); // Lmsd
    setControlValue("ltap_hml", Component_MFH.sngH_f); // H_ml
    if (Number.isFinite(Number(LTA_module.snggr)) && Number(LTA_module.snggr) !== -1) {
      setControlValue("ltap_grooveRadius_gr", LTA_module.snggr); // gr (groove)
    }

    const comboControl = this.inspectionDataFormGroup.get("ltap_2s2cBox");
    if (comboControl && CalcTemplate.intSCbox !== -1) {
      comboControl.setValue(CalcTemplate.intSCbox === 1 ? "Yes" : "No");
    }
  }

  updateFormControlsForLaminations(): void {
    let comboBox1_DI_Equip_Hyd_formControl =
      this.getComboBox1_DI_Equip_Hyd_formControl();
    let comboBox2_DI_Equip_Hyd_formControl =
      this.getComboBox2_DI_Equip_Hyd_formControl();
    let comboBox3_DI_Equip_Hyd_formControl =
      this.getComboBox3_DI_Equip_Hyd_formControl();

    if (Laminations_module.intBulge != -1) {
      if (Laminations_module.intBulge == 0) {
        comboBox1_DI_Equip_Hyd_formControl.patchValue("No");
        this.div_for_comboBox2_DI_Equip_Hyd_visible = true;
      } else if (Laminations_module.intBulge == 1) {
        comboBox1_DI_Equip_Hyd_formControl.setValue("Yes");
        this.div_for_comboBox2_DI_Equip_Hyd_visible = false;
        this.div_for_comboBox3_DI_Equip_Hyd_visible = false;
        this.requirementsForLaminationApproved = false;
      }
    }

    if (Laminations_module.intH2 != -1 && !Laminations_module.intBulge) {
      if (Laminations_module.intH2 == 0) {
        comboBox2_DI_Equip_Hyd_formControl.setValue("No");
        this.div_for_comboBox3_DI_Equip_Hyd_visible = true;
      } else if (Laminations_module.intH2 == 1) {
        comboBox2_DI_Equip_Hyd_formControl?.setValue("Yes");
        this.div_for_comboBox3_DI_Equip_Hyd_visible = false;
        this.requirementsForLaminationApproved = false;
      }
    }

    if (
      Laminations_module.intCrackCheck != -1 &&
      !Laminations_module.intH2 &&
      !Laminations_module.intBulge
    ) {
      if (Laminations_module.intCrackCheck == 0) {
        comboBox3_DI_Equip_Hyd_formControl.setValue("No");
        this.requirementsForLaminationApproved = true;
      } else if (Laminations_module.intCrackCheck == 1) {
        comboBox3_DI_Equip_Hyd_formControl?.setValue("Yes");
        this.requirementsForLaminationApproved = false;
      }
    }

    Laminations_module.updateRemainingInspectionDataFormControls(
      this.inspectionDataFormGroup
    );
  }

  onChangeRadioButton1_DI(typeOfMetalLoss: string) {
    let textBox6_DI_snggrEnable;
    if (typeOfMetalLoss == "radioButton1_DI_enabled") {
      LTA_module.intLTA_type = 0;
      textBox6_DI_snggrEnable = false;
      switch (Component_MAWP.strD_iclass) {
        case 0:
          GML_module.intanalysis_type = 0;
          break;
        case 1:
        case 2:
          //local-thin-area-lta
          LTA_module.intLTA_type = 0;
          textBox6_DI_snggrEnable = false;
          break;
        case 3:
          textBox6_DI_snggrEnable = true;
          break;
        case 5:
          Component_MAWP.strD_class = "Blister";
          textBox6_DI_snggrEnable = true;
          break;
      }
    } else {
      LTA_module.intLTA_type = 1;
      textBox6_DI_snggrEnable = true;
      switch (Component_MAWP.strD_iclass) {
        case 0:
          GML_module.intanalysis_type = 1;
          break;
        case 1:
        case 2:
          // Groove
          LTA_module.intLTA_type = 1;
          textBox6_DI_snggrEnable = true;
          break;
        case 3:
          textBox6_DI_snggrEnable = true;
          break;
        case 5:
          Component_MAWP.strD_class = "HIC";
          textBox6_DI_snggrEnable = true;
          break;
      }
    }
    this.inspectionDataFormGroup
      .get("textBox6_DI_snggr")
    [textBox6_DI_snggrEnable ? "enable" : "disable"]();
  }

  onChangeComboBox1_DI(comboBox1Value: string) {
    let textBox1_DI_formControl = this.getTextBox1_DI_formControl();
    switch (Component_MAWP.strD_iclass) {
      case 4: // Pitting
        break;
      case 6: //Crack
        Crack_Module.intcrack_location = Number(comboBox1Value);
        this.comboBox1_DI_index = Number(comboBox1Value);
        break;
      case 7: // Dent    
        let textBox1_DI_EquipInfo_formControl =
          this.getTextBox1_DI_EquipInfo_formControl();
        if (comboBox1Value == "No") {
          Dent_Module.intd_key = 0;
          textBox1_DI_formControl.setValue("");
          textBox1_DI_EquipInfo_formControl.enable();
        } else if (comboBox1Value == "Yes") {
          Dent_Module.intd_key = 1;
          textBox1_DI_formControl.setValue("");
          textBox1_DI_EquipInfo_formControl.disable();
        }
        break;
      case 8: // DentGouge
        if (comboBox1Value == "No") {
          Dent_Module.intd_key = 0;
          this.updateComponentData(false);
          textBox1_DI_formControl.setValue("");
        } else if (comboBox1Value == "Yes") {
          Dent_Module.intd_key = 1;
          this.updateComponentData(true);
          textBox1_DI_formControl.setValue("");
        }
        break;
      default: //for other calculations
        let structuralDiscountinuities = comboBox1Value;
        if (structuralDiscountinuities == "No") {
          CalcTemplate.intSCbox = 0;
        } else {
          CalcTemplate.intSCbox = 1;
        }
        break;
    }
  }

  onChangeTextBox1_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 0: // GML
          GML_module.sngtam = parseFloat(e.target.value);
          break;
        case 3: // Gouge
        case 9: // Laminations
        case 1: // LTA
          LTA_module.sngtmm = parseFloat(e.target.value);
          break;
        case 2: // LTA Profile
          if (e.target.value.toString().includes(".")) {
            let textBox1_DI_formControl: FormControl =
              this.getTextBox1_DI_formControl();
            textBox1_DI_formControl.setValue("");
            return;
          }
          LTAP_module.intnum_t_pt = parseFloat(e.target.value);
          break;
        case 5: //BlisterHIC
          LTA_module.sngss = parseFloat(e.target.value);
          break;
        case 6: //Crack
          Crack_Module.sngA_crack = parseFloat(e.target.value);
          break;
        case 7: //Dents
        case 8: // DentGouge
          if (Dent_Module.intd_key === 0)
            Dent_Module.sngd_d0 = parseFloat(e.target.value);
          else if (Dent_Module.intd_key === 1)
            Dent_Module.sngd_dp = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox2_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 0:
          LTA_module.sngtmm = parseFloat(e.target.value);
          break;
        case 5: // BLister HI
          LTA_module.sngcc = parseFloat(e.target.value);
          break;
        case 6: // Crack
          Crack_Module.sngC_crack = parseFloat(e.target.value);
          break;
        case 7: // Dents
          Dent_Module.sngLw = parseFloat(e.target.value);
          break;
        case 8: // DentGouge
          Dent_Module.sngd_g = parseFloat(e.target.value);
          break;
        case 9: // Laminations
          LTA_module.sngss = parseFloat(e.target.value);
          break;
        default:
          CalcTemplate.sngFCAml = parseFloat(e.target.value);
          break;
      }
    }
  }
  onChangeTextBox3_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 0: //GML
          CalcTemplate.sngH_f = parseFloat(e.target.value);
          Component_MFH.sngH_f = parseFloat(e.target.value);
          break;
        case 1: // LTA
          LTA_module.sngss = parseFloat(e.target.value);
          break;
        case 2: // LTA Profile
          LTAP_module.sngGrid_spacing = parseFloat(e.target.value);
          break;
        case 3: //Gouge
          LTA_module.sngss = parseFloat(e.target.value);
          break;
        case 4: //Pitting
          CalcTemplate.sngH_f = parseFloat(e.target.value);
          break;
        case 5: // Blister HIC
          BlisterHIC_module.sngtmm_ID = parseFloat(e.target.value);
          LTA_module.sngtmm = parseFloat(e.target.value);
          break;
        case 6: //Crack
          Dent_Module.sngLw = parseFloat(e.target.value);
          break;
        case 7: // Dents
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 8: // DentGouge
          LTA_module.sngtmm = parseFloat(e.target.value);
          break;
        case 9: //Laminations
          LTA_module.sngcc = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox3_DI_sngH_f(e) {
    if (Utility.isTextADouble(e.target.value)) {
      const hMl = parseFloat(e.target.value);
      CalcTemplate.sngH_f = hMl;
      Component_MFH.sngH_f = hMl;

      if (Number.isFinite(Number(Component_MFH.sngH_c))) {
        Component_MFH.sngH_w = hMl - Number(Component_MFH.sngH_c);
      }
    }
  }

  onChangeTextBox6_DI_external(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 1: // LTA
          LTA_module.sngEdgeofOppoMLL2 = parseFloat(e.target.value);
          break;
        case 3: //Gouge
          LTA_module.sngEdgeofOppoMLL2 = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox5_DI_external(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 1: // LTA
          LTA_module.sngEdgeofMLL1 = parseFloat(e.target.value);
          CalcTemplate.sngEdgeofMLL1 = parseFloat(e.target.value);
          break;
        case 3: //Gouge
          LTA_module.sngEdgeofMLL1 = parseFloat(e.target.value);
          CalcTemplate.sngEdgeofMLL1 = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox7_DI_external(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 2: // LTAPD
          LTAP_module.sngAxialEdgeofMLL1 = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox8_DI_external(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 2: // LTAPD
          LTAP_module.sngAxialEdgeofMLL2 = parseFloat(e.target.value);
          break;
      }
    }
  }

  textBox4_DI_Enabling(enabled: boolean) {
    this.textBox4_DI_Enabled = enabled;
    this.inspectionDataFormGroup.controls["textBox4_DI"].enable();
  }

  onChangeTextBox4_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 1: // LTA
          LTA_module.sngcc = parseFloat(e.target.value);
          break;
        case 2: // LTAP
          LTA_module.sngcc = parseFloat(e.target.value);
          break;
        case 3: // Gouge
          LTA_module.sngcc = parseFloat(e.target.value);
          break;
        case 5: // Blister HIC
          BlisterHIC_module.sngBp = parseFloat(e.target.value);
          BlisterHIC_module.sngtmm_OD = parseFloat(e.target.value);
          break;
        case 6: // Crack
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 7: // Dents
          Dent_Module.sngLd = parseFloat(e.target.value);
          break;
        case 8: // DentGouge
          CalcTemplate.sngFCAml = parseFloat(e.target.value);
          break;
        case 9: // Laminations
          Laminations_module.sngLh = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox5_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 1: // LTA
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 2: //LTAP
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 3: //Gouge
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 5: //BLister & HIC
          BlisterHIC_module.sngLb = parseFloat(e.target.value);
          break;
        case 7: // Dents
          Dent_Module.sngrd = parseFloat(e.target.value);
          break;
        case 8: // DentGouge
          Dent_Module.sngLw = parseFloat(e.target.value);
          break;
        case 9: //Laminations
          Laminations_module.sngLs = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox6_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 1: //LTA
          LTA_module.snggr = parseFloat(e.target.value);
          break;
        case 2: //LTAP
          LTA_module.snggr = parseFloat(e.target.value);
          break;
        case 3: //Gouge
          LTA_module.snggr = parseFloat(e.target.value);
          break;
        case 5: //BListerHIC
          Dent_Module.sngLw = parseFloat(e.target.value);
          break;
        case 8: //DentGouge
          CalcTemplate.sngLmsd = parseFloat(e.target.value);
          break;
        case 9: //Laminations
          Dent_Module.sngLw = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox7_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      const value = parseFloat(e.target.value);
      switch (Component_MAWP.strD_iclass) {
        case 0: // GML MFH path
          CalcTemplate.sngFCAml = value;
          break;
        case 1: //LTA
          CalcTemplate.sngH_f = value;
          Component_MFH.sngH_f = value;
          if (Number.isFinite(Number(Component_MFH.sngH_c))) {
            Component_MFH.sngH_w = value - Number(Component_MFH.sngH_c);
          }
          break;
        case 2: //LTAP
          CalcTemplate.sngH_f = value;
          Component_MFH.sngH_f = value;
          if (Number.isFinite(Number(Component_MFH.sngH_c))) {
            Component_MFH.sngH_w = value - Number(Component_MFH.sngH_c);
          }
          break;
        case 3: //Gouge
          CalcTemplate.sngH_f = value;
          Component_MFH.sngH_f = value;
          if (Number.isFinite(Number(Component_MFH.sngH_c))) {
            Component_MFH.sngH_w = value - Number(Component_MFH.sngH_c);
          }
          break;
        case 5: //BlisterHIC
          CalcTemplate.sngLmsd = value;
          break;
        case 8: //DentGouge
          Dent_Module.sngLd = value;
          break;
        case 9: //Laminations
          CalcTemplate.sngLmsd = value;
          break;
      }
    }

    this.updateHmlAgainstHcValidation();
  }

  onChangeTextBox8_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 8: //DentGouge
          Dent_Module.sngrd1 = parseFloat(e.target.value);
          break;
      }
    }
  }

  onChangeTextBox9_DI(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 8: //DentGouge
          Dent_Module.sngrd = parseFloat(e.target.value);
          break;
      }
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // LTAP (Local Metal Loss Profile Data) MFH mode handlers
  // These handlers are used by the tanks-ltap-inspection-fields child component
  // ═══════════════════════════════════════════════════════════════════════════════
  onChangeLtap_2s2cBox(value: string): void {
    // Same logic as onChangeComboBox1_DI default case
    if (value === "No") {
      CalcTemplate.intSCbox = 0;
    } else {
      CalcTemplate.intSCbox = 1;
    }
  }

  onChangeLtap_metalLossLength_s(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      LTAP_module.sngGrid_spacing = value;
    }
  }

  onChangeLtap_numMeasurements(e: Event): void {
    const value = parseInt((e.target as HTMLInputElement).value, 10);
    if (!isNaN(value)) {
      LTAP_module.intnum_t_pt = value;
    }
  }

  onChangeLtap_fcaml(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      CalcTemplate.sngFCAml = value;
    }
  }

  onChangeLtap_circLength_c(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      LTA_module.sngcc = value;
    }
  }

  onChangeLtap_hml(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      Component_MFH.sngH_f = value;
      CalcTemplate.sngH_f = value;
      if (Number.isFinite(Number(Component_MFH.sngH_c))) {
        Component_MFH.sngH_w = value - Number(Component_MFH.sngH_c);
      }
    }
  }

  onChangeLtap_lmsd(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      CalcTemplate.sngLmsd = value;
    }
  }

  onChangeLtap_gr(e: Event): void {
    const value = parseFloat((e.target as HTMLInputElement).value);
    if (Utility.isTextADouble(String(value))) {
      LTA_module.snggr = value;
    }
  }

  onChangeComboBox1_DI_Equip_Hyd(e: { target: { value: string } }) {
    {
      if (e.target.value == "No") {
        Laminations_module.intBulge = 0;
        this.div_for_comboBox2_DI_Equip_Hyd_visible = true;
      } else {
        if (e.target.value == "Yes") {
          let comboBox2_DI_Equip_Hyd_formControl =
            this.getComboBox2_DI_Equip_Hyd_formControl();
          comboBox2_DI_Equip_Hyd_formControl.setValue("");
          let comboBox3_DI_Equip_Hyd_formControl =
            this.getComboBox3_DI_Equip_Hyd_formControl();
          comboBox3_DI_Equip_Hyd_formControl.setValue("");
          Laminations_module.intBulge = 1;
          this.openGenericErrorModal(
            "Use Blisters assessment procedure to assess the lamination.  Current assessment aborted.",
            "Failed Level 1 Assessment"
          );
        }

        this.div_for_comboBox2_DI_Equip_Hyd_visible = false;
        this.div_for_comboBox3_DI_Equip_Hyd_visible = false;
        this.requirementsForLaminationApproved = false;
      }
    }
  }

  onChangeComboBox2_DI_Equip_Hyd(e: { target: { value: string } }) {
    {
      if (e.target.value == "No") {
        Laminations_module.intH2 = 0;
        this.div_for_comboBox3_DI_Equip_Hyd_visible = true;
      } else {
        if (e.target.value == "Yes") {
          let comboBox3_DI_Equip_Hyd_formControl =
            this.getComboBox3_DI_Equip_Hyd_formControl();
          comboBox3_DI_Equip_Hyd_formControl.setValue("");
          Laminations_module.intH2 = 1;
          this.openGenericErrorModal(
            "Use HIC Damage assessment procedure to assess the lamination.  Current assessment aborted.",
            "Failed Level 1 Assessment"
          );
        }

        this.div_for_comboBox3_DI_Equip_Hyd_visible = false;
        this.requirementsForLaminationApproved = false;
      }
    }
  }

  onChangeComboBox3_DI_Equip_Hyd(e: { target: { value: string } }) {
    {
      if (e.target.value == "No") {
        Laminations_module.intCrackCheck = 0;
        this.requirementsForLaminationApproved = true;
        this.inspectionDataFormGroup.get("textBox6_DI_snggr")["enable"]();
      } else {
        if (e.target.value == "Yes") {
          Laminations_module.intCrackCheck = 1;
          this.openGenericErrorModal(
            "Use Crack-Like Indications assessment procedure to assess the lamination.  Current assessment aborted.",
            "Failed Level 1 Assessment"
          );
        }

        this.requirementsForLaminationApproved = false;
      }
    }
  }

  comboBox2_DI_Enabling(enabled: boolean) {
    this.comboBox2_DI_Enabled = enabled;
  }

  onChangeComboBox2_DI(comboBox2Value: string) {
    switch (Component_MAWP.strD_iclass) {
      case 5: // BListerHIC
        if (comboBox2Value === "No") {
          BlisterHIC_module.intPcrack = 0;
          BlisterHIC_module.intH2 = 0;
        } else if (comboBox2Value === "Yes") {
          BlisterHIC_module.intPcrack = 1;
          BlisterHIC_module.intH2 = 1;
        }
        break;
      case 6: // Crack
        if (comboBox2Value === "Parallel") Crack_Module.intcrack_orien = 0;
        else if (comboBox2Value === "Perpendicular")
          Crack_Module.intcrack_orien = 1;
        break;
      case 8: //DentGouge
        if (comboBox2Value === "yes") {
          this.comboBox2_DI_Enabling(false);
        } else {
          this.comboBox2_DI_Enabling(true);
        }
        break;
      case 9: // Laminations
        if (comboBox2Value === "No") Laminations_module.intElevation = 0;
        else Laminations_module.intElevation = 1;
        break;
    }
  }

  onChangeComboBox3_DI(comboBox3Value: string) {
    switch (Component_MAWP.strD_iclass) {
      case 5:
        if (comboBox3Value === "No") BlisterHIC_module.intVent = 0;
        else if (comboBox3Value === "Yes") BlisterHIC_module.intVent = 1;
        break;
      case 6:
        if (comboBox3Value === "No") Crack_Module.intsize_accuracy = 0;
        else if (comboBox3Value === "Yes") Crack_Module.intsize_accuracy = 1;
        break;
    }
  }

  onChangeTextBox1_DI_EquipInfo(e) {
    if (Utility.isTextADouble(e.target.value)) {
      switch (Component_MAWP.strD_iclass) {
        case 7:
          Dent_Module.sngP_op = parseFloat(e.target.value);
          break;
      }
    }
  }

  equipHydInLaminationsCorrect(): boolean {
    let comboBox1_DI_Equip_Hyd_formControl =
      this.getComboBox1_DI_Equip_Hyd_formControl();
    let comboBox2_DI_Equip_Hyd_formControl =
      this.getComboBox2_DI_Equip_Hyd_formControl();
    let comboBox3_DI_Equip_Hyd_formControl =
      this.getComboBox3_DI_Equip_Hyd_formControl();

    if (comboBox1_DI_Equip_Hyd_formControl.value == "") {
      this.openGenericErrorModal(
        "Please select an answer for the surface bulging question.",
        "Failed Level 1 Assessment"
      );
      return false;
    } else if (comboBox1_DI_Equip_Hyd_formControl.value == "Yes") {
      this.openGenericErrorModal(
        "Use Blisters assessment procedure to assess the lamination. Current assessment aborted.",
        "Failed Level 1 Assessment"
      );
      return false;
    } else if (comboBox2_DI_Equip_Hyd_formControl.value == "") {
      this.openGenericErrorModal(
        "Please select an answer for the hydrogen changing question.",
        "Failed Level 1 Assessment"
      );
      return false;
    } else if (comboBox2_DI_Equip_Hyd_formControl.value == "Yes") {
      this.openGenericErrorModal(
        "Use HIC Damage assessment procedure to assess the lamination.  Current assessment aborted.",
        "Failed Level 1 Assessment"
      );
      return false;
    } else if (comboBox3_DI_Equip_Hyd_formControl.value == "") {
      this.openGenericErrorModal(
        "Use Crack-Like Indications assessment procedures to assess the lamination.",
        "Failed Level 1 Assessment"
      );
      return false;
    } else if (comboBox3_DI_Equip_Hyd_formControl.value == "Yes") {
      this.openGenericErrorModal(
        "Use Crack-Like Indications assessment procedures to assess the lamination.  Current assessment aborted.",
        "Failed Level 1 Assessment"
      );
      return false;
    }

    return true;
  }

  onPressPictureBox2_DI() {
    // console.log("[InspectionData] onPressPictureBox2_DI start", {
    //   iclass: Component_MAWP.strD_iclass,
    //   isMfhMode: this.isMfhMode,
    //   analysisRadio: this.inspectionDataFormGroup.get("radioButton_DI")?.value,
    // });

    Object.keys(this.inspectionDataFormGroup.controls).forEach((key) => {
      this.inspectionDataFormGroup.get(key).markAsDirty();
    });

    let resultFromValidation = false;

    switch (Component_MAWP.strD_iclass) {
      case 0: //GML
        this.onPressPictureBox2_DI_GML();
        break;
      case 1: // LTA
        this.onPressPictureBox2_DI_LTA();
        break;
      case 2: // LTA Profile
        this.onPressPictureBox2_DI_LTA_Profile();
        break;
      case 3: //Gouge
        this.onPressPictureBox2_DI_Gouge();
        break;
      case 4: // Pitting
        this.onPressPictureBox2_DI_Pitting();
        break;
      case 5: //BlisterHIC
        this.onPressPictureBox2_DI_BlisterHIC();
        break;
      case 6: //Crack
        this.onPressPictureBox2_DI_CrackLike();
        break;
      case 7: // Dent
        this.onPressPictureBox2_DI_Dent();
        break;
      case 8: // DentGouge
        this.onPressPictureBox2_DI_DentGouge();
        break;
      case 9: //Laminations
        this.onPressPictureBox2_DI_Laminations();
        break;
    }

    // console.log("[InspectionData] Emitting inspectionDataResult", {
    //   hasResult: !!this.result,
    //   resultLength: this.result?.length || 0,
    // });
    this.inspectionDataResult.emit(this.result);
  }

  onPressPictureBox2_DI_GML() {
    const isMfhSecondAnalysis = this.isMfhSecondAnalysisSelected();

    if (this.isMfhMode && !isMfhSecondAnalysis) {
      if (!this.validateMfhInspectionDataForNow()) {
        return;
      }

      this.result = this.runMfhAverageThicknessCalc(false);
      this.nextStep.emit();
      return;
    }

    if (isMfhSecondAnalysis) {
      if (!this.validateMfhInspectionDataForNow()) {
        return;
      }

      this.result = this.runMfhAverageThicknessCalc(true);
      this.nextStep.emit();
      return;
    }

    let resultFromValidation = GML_module.check_GML_Data(
      this.inspectionDataFormGroup
    );

    this.validation_list = GML_module.validationMessage;
    // console.log("[InspectionData][GML] Validation status", {
    //   resultFromValidation,
    //   validationCount: this.validation_list?.length || 0,
    //   validations: this.validation_list,
    // });
    if (!resultFromValidation) {
      return;
    }

    this.result = GML_module.GML_calc();
    // console.log("[InspectionData][GML] Validation passed, emitting nextStep", {
    //   resultLength: this.result?.length || 0,
    // });
    this.nextStep.emit();
  }

  private isMfhSecondAnalysisSelected(): boolean {
    const secondAnalysisSelected =
      this.inspectionDataFormGroup.get("radioButton_DI")?.value === "radioButton2_DI_enabled";
    if (!secondAnalysisSelected) {
      return false;
    }

    const hasMfhState =
      Number(Component_MFH.sngtnom) > 0 ||
      Number(Component_MFH.sngID) > 0 ||
      Number(Component_MFH.sngDi) > 0;

    return this.isMfhMode || hasMfhState;
  }
// MFH data
  private validateMfhInspectionDataForNow(): boolean {
    const messages: string[] = [];

    const tam = Number(this.inspectionDataFormGroup.get("textBox1_DI")?.value);
    const tmm = Number(this.inspectionDataFormGroup.get("textBox2_DI")?.value);
    const H_ml = Number(this.inspectionDataFormGroup.get("textBox3_DI_sngH_ml")?.value);
    const hC = Number(Component_MFH.sngH_c); // H_c from MFH setup screen
    const fcaMl = Number(this.inspectionDataFormGroup.get("textBox7_DI_sngfcaML")?.value);
    const tnom = Number(Component_MFH.sngtnom);
    const hL = Number(Component_MFH.sngH_L);

    if (!Number.isFinite(tam) || tam <= 0) {
      messages.push("Average measured thickness, tam - cannot be less than or equal to zero.");
    }

    if (!Number.isFinite(tmm) || tmm <= 0) {
      messages.push("Minimum measured thickness, tmm - cannot be less than or equal to zero.");
    }

    if (Number.isFinite(tmm) && Number.isFinite(tnom) && tnom > 0 && tmm > tnom) {
      messages.push("Minimum measured thickness, tmm - cannot be greater than tnom.");
    }

    if (Number.isFinite(tam) && Number.isFinite(tnom) && tnom > 0 && tam > tnom) {
      messages.push("Average measured thickness (tam) cannot be greater than nominal thickness (tnom).");
    }

    if (Number.isFinite(tmm) && Number.isFinite(tam) && tmm > tam) {
      messages.push("Minimum measured thickness, tmm - cannot be greater than Average measured thickness tam.");
    }

    if (!Number.isFinite(fcaMl) || fcaMl < 0) {
      messages.push("FCAml - cannot be less than zero.");
    }

    if (Number.isFinite(fcaMl) && Number.isFinite(tmm) && fcaMl >= tmm) {
      messages.push("FCAml - cannot be greater than or equal to tmm.");
    }

    if (Number.isFinite(fcaMl) && Number.isFinite(tam) && fcaMl >= tam) {
      messages.push("FCAml - cannot be greater than or equal to tam.");
    }

    if (!Number.isFinite(H_ml) || H_ml < 0) {
      messages.push("Distance from the lower edge of the flaw to the bottom of the tank, H_ml - cannot be less than zero.");
    }

    if (Number.isFinite(H_ml) && Number.isFinite(hC) && H_ml < hC) {
      messages.push("Distance from the lower edge of the flaw to the bottom of the tank, H_ml must be greater or equal than the distance from the lower edge of the shell course under assessment to the tank floor, H_c");
    }

    this.validation_list = messages;
    if (messages.length > 0) {
      console.warn("[MFH Inspection] Validation failed", messages);
    }
    return messages.length === 0;
  }

  private isLmlEquationLogContext(): boolean {
    return this.isMfhMode && ["LTA", "LTAP", "Gouge"].includes(Component_MAWP.strD_class);
  }

  private isMfhLmlContext(): boolean {
    return this.isMfhMode && [1, 2, 3].includes(Component_MAWP.strD_iclass);
  }

  private runMfhAverageThicknessCalc(isMfhRadioSelected: boolean = false): string {
    const tam = Number(this.inspectionDataFormGroup.get("textBox1_DI")?.value ?? 0);
    const tmm = Number(this.inspectionDataFormGroup.get("textBox2_DI")?.value ?? 0);
    // Prioritize CalcTemplate.sngFCAml (set by change handler) over form control
    const fcaMl = Number.isFinite(Number(CalcTemplate.sngFCAml)) && Number(CalcTemplate.sngFCAml) >= 0
      ? Number(CalcTemplate.sngFCAml)
      : Number(this.inspectionDataFormGroup.get("textBox7_DI_sngfcaML")?.value ?? 0);
    const tminFromComponent = Number(Component_MFH.sngtmin);
    const tnom = Number(Component_MFH.sngtnom);
    const unitSelect = Number(this.intUnit);
    const d = Number(Component_MFH.sngID); // D from insideDiameter_MFH input field
    const s = Number(Component_MFH.sngS_stress);
    const e = Number(Component_MFH.sngE_c);
    const hL = Number(Component_MFH.sngH_L);
    const hC = Number(Component_MFH.sngH_c); // H_c from MFH setup screen
    const H_ml = Number(this.inspectionDataFormGroup.get("textBox3_DI_sngH_ml")?.value ?? 0); // H_ml: textBox3_DI_sngH_ml
    const hW = H_ml - hC; // Auto-calculate H_w from H_ml - H_c  
    const sg = Number(Component_MFH.sngs_g);
    const fcaDesign = Number(Component_MFH.sngFCAi) + Number(Component_MFH.sngFCAe);

    const minThicknessFloor = unitSelect === 0 ? 0.1 : 2.5;
    const hydroCoefficient = unitSelect === 0 ? 2.6 : 4.9;
    const oneFootInCurrentUnits = unitSelect === 0 ? 1 : 0.3048;
    const oneFootDisplay = unitSelect === 0 ? "1 ft" : "0.3048 m";
    const oneInchInCurrentUnits = unitSelect === 0 ? 1 : 25.4;

    // Use D directly from input field (no unit conversion)
    const tankDiameterInFeet = d;
    const dInside = Number(Component_MFH.sngDi);// Calculated inside diameter from MFH setup
    GML_module.sngtam = tam;
    LTA_module.sngtmm = tmm;
    CalcTemplate.sngFCAml = fcaMl;
    CalcTemplate.sngH_f = H_ml;
    Component_MFH.sngH_f = H_ml;
    Component_MFH.sngH_w = hW;

    const tS = tam - fcaMl;

    let tminStructuralBase = 0;
    if (tankDiameterInFeet < 50) {
      tminStructuralBase = 0.1875 * oneInchInCurrentUnits;
    } else if (tankDiameterInFeet <= 120) {
      tminStructuralBase = 0.25 * oneInchInCurrentUnits;
    } else if (tankDiameterInFeet <= 200) {
      tminStructuralBase = 0.3125 * oneInchInCurrentUnits;
    } else {
      tminStructuralBase = 0.375 * oneInchInCurrentUnits;
    }
    //const tminStructuralCorosion = tminStructuralBase + fcaDesign; *** Old code, not used in current calculations
    const tminStructural = tminStructuralBase; // Excludes corrosion allowance, as per current MFH inspection data calculations

    const tminDenominator = s * e;
    const h_ml_top = hL - H_ml; // r1
    const h_hC_top = hL - hC - oneFootInCurrentUnits; // r2

    // H_L - H_c + oneFootInCurrentUnits --> r2
    // H_L - H_ml --> r1
    const tminHydroEquation =
      hW < oneFootInCurrentUnits
        ? `tmin_hydro = (${hydroCoefficient} * (H_L - H_f - ${oneFootDisplay}) * D * s_g) / (S * E)`
        : `tmin_hydro = (${hydroCoefficient} * (H_L - H_f) * dInside * s_g) / (S * E)`;
    const tminHydro =
      tminDenominator !== 0
        ? (hW < oneFootInCurrentUnits
            ? (hydroCoefficient * (h_hC_top) * dInside * sg) / tminDenominator //This is Tmin_hydro_R2
            : (hydroCoefficient * h_ml_top * dInside * sg) / tminDenominator)  // This is Tmin_hydro_r1
        : NaN;
        console.log("Testing [MFH Inspection] tminHydro", {
          tminHydro,
          h_hC_top,
          h_ml_top,
          dInside, 
          sg,
          tminDenominator,
          hW,
        });

    const tminHydroEquationWithValues =
      hW < oneFootInCurrentUnits
        ? `tmin_hydro = (${hydroCoefficient} * (${h_hC_top}) * ${dInside} * ${sg}) / (${s} * ${e}) = ${tminHydro}`
        : `tmin_hydro = (${hydroCoefficient} * ${h_ml_top} * ${dInside} * ${sg}) / (${s} * ${e}) = ${tminHydro}`;

    const tmin_r = Math.max(tminStructural, tminHydro);
    console.log("Testing [MFH Inspection] tmin_r", {
      tminStructural,
      tminHydro,
      tmin_r,
    });

    // MFH Hydro for inspection data calcs: 
    const inspMFH_hydro =
          (hW >= oneFootInCurrentUnits
            ? ((tam - fcaMl) * s) / (hydroCoefficient * d * sg) + H_ml //MFHhydro_r1
            : ((tam - fcaMl) * s) / (hydroCoefficient * d * sg) + hC + oneFootInCurrentUnits // MFHhydro_r2
          );
          console.log(" TESTING [MFH Inspection] inspMFH_hydro", {
            inspMFH_hydro,
            hW,
            tam,
            fcaMl,
            s,
            hydroCoefficient,
            d,
            sg,
            H_ml,
            hC,
          });
    const MFH_r = Math.min(Component_MFH.sngMFH, inspMFH_hydro);

    //End MFH Hydro Equations for inspection data calcs


    const tLim = Math.max(0.2 * tnom, minThicknessFloor);
    const criteria1Pass = tS >= tmin_r;
    //const primary1Pass = tS >= tmin_r;
    //const primary2Pass = Number(tmm.toFixed(3)) >= Number((0.9 * tam).toFixed(3));
    const primaryPass = Number(tmm.toFixed(3)) >= Number((0.9 * tam).toFixed(3));
    // Fallback check applied only when the primary tam/tmm criteria fail
    const secondary1Pass = tS >= tmin_r; //tS = tam - FCAml 
    const secondary2Pass = (tmm - fcaMl) >= tmin_r;
    const secondaryPass =  secondary2Pass; //&& secondary1Pass Removed.
    const criteria2Pass = secondaryPass || primaryPass;
    // tmm >= (.9 * tam)
    // tam - fcaMl >= tmin_r -- Not needed. Only should control Orange Result
    // (tmm - fcaMl) >= tmin_r -- Superseeds the .9 check if it is true. No need to check .9
    const criteria3Target = Math.max(0.5 * tmin_r, tLim);
    const criteria3Pass = (tmm - fcaMl) >= criteria3Target;
    const criteria5Pass = (tmm - fcaMl) >= tmin_r;
    const criteria4Pass = MFH_r > Component_MFH.sngMFH && MFH_r > Component_MFH.sngH_L;
    const criteriaOrange = MFH_r < Component_MFH.sngH_L;
    const MFH_rFail = ((tam - fcaMl) < tminStructural)
    const allPass = criteria2Pass && criteria3Pass;

    if (this.isLmlEquationLogContext()) {
      console.log("[LML Inspection Eq]", {
        equation: tminHydroEquation,
        substituted: tminHydroEquationWithValues,
        inputs: {
          tam,
          tmm,
          FCAml: fcaMl,
          H_ml: H_ml,
          H_c: hC,
          H_L: hL,
          D: d,
          S: s,
          E: e,
          s_g: sg,
        },
        results: {
          tminHydro,
          tminStructural,
          tmin_r,
          tS,
          tLim,
          criteria1Pass,
          criteria2Pass,
          criteria3Target,
          criteria3Pass,
          allPass,
          tminFromComponent,
          fcaDesign,
        },
      });
    }

    const thicknessUnit = unitSelect === 0 ? "inch" : "mm";
    const heightUnit = unitSelect === 0 ? "ft" : "m";
    const thicknessFixed = unitSelect === 0 ? 3 : 1;
    const resultModeLabel = isMfhRadioSelected ? "MFH" : "AMT";

    const c2Left = Number.isFinite(tS) ? tS.toFixed(thicknessFixed) : "NaN";
    const c2Tmin = Number.isFinite(tmin_r) ? tmin_r.toFixed(thicknessFixed) : "NaN";
    const c2Right = Number.isFinite(0.9 * tam) ? (0.9 * tam).toFixed(thicknessFixed) : "NaN";
    const tmmText = Number.isFinite(tmm) ? tmm.toFixed(thicknessFixed) : "NaN";
    const statusText = (pass: boolean) => pass ? "" : "<font color=\"red\">*Fail*</font>";
    const c3Left = Number.isFinite(tmm - fcaMl) ? (tmm - fcaMl).toFixed(thicknessFixed) : "NaN";
    const c3Right = Number.isFinite(criteria3Target) ? criteria3Target.toFixed(thicknessFixed) : "NaN";
    const tLimText = Number.isFinite(tLim) ? tLim.toFixed(thicknessFixed) : "NaN";
    const tminHydroText = Number.isFinite(tminHydro) ? tminHydro.toFixed(thicknessFixed) : "NaN";
    const tminStructuralText = Number.isFinite(tminStructural) ? tminStructural.toFixed(thicknessFixed) : "NaN";

    let result = "";
    if (isMfhRadioSelected === true && !MFH_rFail) { //Check and see if this covers the case where MFH_r is GREATER than.
      result += `MFH_r based on tam - FCAml = ${MFH_r.toFixed(3)} ${heightUnit} ${criteria4Pass ? "=" : "<"} 
      Maximum Design Filling Height, ${Component_MFH.sngH_L.toFixed(3)} ${heightUnit} </br>`;
    }
    if (isMfhRadioSelected === true && MFH_rFail) {
      result += `MFH could not be calculated because tam - FCAml = ${c2Left} ${thicknessUnit} < tmin_structural = ${tminStructuralText} ${thicknessUnit} <font color="red">*Fail*</font></br>`;
    }
    //result += `tmin_hydro = ${tminHydroText} ${thicknessUnit}</br>`;
    //result += `tmin_st = ${tminStructuralText} ${thicknessUnit}</br>`;
    result += `tam - FCAml = ${c2Left} ${thicknessUnit} ${criteria1Pass ? ">=" : "<"} Reduced tmin, tmin_r = ${c2Tmin} ${thicknessUnit}</br>`;
    //result += `tmin = max(tmin_st, tmin_hydro) = ${c2Tmin} ${thicknessUnit}</br>`;
    result += `Limiting t, t_lim = max[0.2 * tnom, ${minThicknessFloor} ${thicknessUnit}] = ${tLimText} ${thicknessUnit}</br>`;
    //result += `max(0.5 * tmin, t_lim) = ${c3Right} ${thicknessUnit}</br>`;
    //result += `<b>Primary Validation:</b></br>`;

    if (!criteria5Pass) { // (tmm - FCAml >= tmin_r)
        result += `tmm = ${tmmText} ${thicknessUnit} ${primaryPass ? ">=" : "<"} 0.9 * tam = ${c2Right} ${thicknessUnit} ${statusText(primaryPass)}</br>`;
    } else {
        result += `tmm - FCAml = ${c3Left} ${thicknessUnit} ${secondary2Pass ? ">=" : "<"} tmin = ${c2Tmin} ${thicknessUnit} ${statusText(secondary2Pass)} </br>`;
    }    

    result += `tmm - FCAml = ${c3Left} ${thicknessUnit} ${criteria3Pass ? ">=" : "<"} max[0.5 * tmin, t_lim] = ${c3Right} ${thicknessUnit}${criteria3Pass ? "" : " <font color=\"red\">*Fail*</font>"}</br>`;

    //result += `</br><b>Overall Result: ${statusText(allPass)}</b></br>`;

    if (allPass) {

      if (!criteria1Pass || criteriaOrange) { // Orange if the case is that tam - FCAml < tmin_r
        result += `</br><font color="orange">The tank can only be operated at the MFH = ${MFH_r.toFixed(3)} ${heightUnit}</font></br>`;
      } else {
        result += `</br><font color="blue">General Metal Loss (${resultModeLabel}) passed Level 1 assessment.</font></br>`;
      }
    } 
    if (!allPass) {
      if (!criteria3Pass) {
        result += `</br><font color="red">General Metal Loss (${resultModeLabel}) failed the Level 1 assessment.</br>Consider performing a Level 3 Assessment.</font></br>`;
      } else {
        result += `</br><font color="red">General Metal Loss (${resultModeLabel}) failed the Level 1 assessment.</br>Consider performing a Local Metal Loss or Level 3 Assessment.</font></br>`;
      }
    }

    Component_MFH.mfhGmlCalcResult = result;
    Component_MFH.mfhLmlCalcResult = "";
    Component_MFH.snap_tam = tam;
    Component_MFH.snap_tmm = tmm;
    Component_MFH.snap_FCAml = fcaMl;
    Component_MFH.snap_sLong = 0;
    Component_MFH.snap_cCirc = 0;
    Component_MFH.snap_lmsd = 0;
    Component_MFH.snap_gr = NaN;

    GML_module.gmlCalcResult = result;
    return result;
  }

  private runMfhSelectedCalc(): string {
    const isLmlMfhContext = this.isMfhLmlContext();
    const tam = Number.isFinite(Number(GML_module.sngtam)) && Number(GML_module.sngtam) > 0
      ? Number(GML_module.sngtam)
      : Number(this.inspectionDataFormGroup.get("textBox1_DI")?.value ?? 0);
    const tmm = Number.isFinite(Number(LTA_module.sngtmm)) && Number(LTA_module.sngtmm) > 0
      ? Number(LTA_module.sngtmm)
      : Number(this.inspectionDataFormGroup.get("textBox2_DI")?.value ?? 0);
    const sLong = Number(this.inspectionDataFormGroup.get("textBox3_DI")?.value ?? 0);
    const cCirc = Number(this.inspectionDataFormGroup.get("textBox4_DI")?.value ?? 0);
    const hMlFromLmlControl = Number(this.inspectionDataFormGroup.get("textBox7_DI")?.value ?? NaN);
    const hMl = [1, 2, 3].includes(Component_MAWP.strD_iclass) && Number.isFinite(hMlFromLmlControl)
      ? hMlFromLmlControl
      : Number.isFinite(Number(Component_MFH.sngH_f)) && Number(Component_MFH.sngH_f) >= 0
        ? Number(Component_MFH.sngH_f)
        : Number.isFinite(Number(CalcTemplate.sngH_f)) && Number(CalcTemplate.sngH_f) >= 0
          ? Number(CalcTemplate.sngH_f)
          : Number(this.inspectionDataFormGroup.get("textBox3_DI_sngH_f")?.value ?? 0);
    const lmsd = Number(this.inspectionDataFormGroup.get("textBox5_DI")?.value ?? 0);
    const fcaMl = Number.isFinite(Number(CalcTemplate.sngFCAml)) && Number(CalcTemplate.sngFCAml) >= 0
      ? Number(CalcTemplate.sngFCAml)
      : Number(this.inspectionDataFormGroup.get("textBox7_DI_sngH_ml")?.value ?? 0);

    const tc = Number(Component_MFH.sngtc);
    // Use Di (ID corrected for LOSSi + FCAi) rather than raw ID for Lmsd / lambda.
    const dRaw = Number(Component_MFH.sngDi);
    const d = Number.isFinite(dRaw) && dRaw > 0 ? dRaw : Number(Component_MFH.sngID);
    const hL = Number(Component_MFH.sngH_L);
    const eC = Number(Component_MFH.sngE_c);
    const eLSource = Number(Component_MAWP.sngE_L) > 0
      ? Number(Component_MAWP.sngE_L)
      : Number(Component_MAEP.sngE_L);
    const eL = eLSource > 0 ? eLSource : (eC > 0 ? eC : 1);
    const rsfA = Number.isFinite(Number(CalcTemplate.sngRSF_a)) && Number(CalcTemplate.sngRSF_a) > 0
      ? Number(CalcTemplate.sngRSF_a)
      : 0.9;
    const intUnit = Number(this.intUnit);
    const diameterInThicknessUnits = intUnit === 0 ? d * 12 : d * 1000;

    CalcTemplate.sngFCAml = fcaMl;
    CalcTemplate.sngH_f = hMl;
    CalcTemplate.sngLmsd = lmsd;
    Component_MFH.sngH_f = hMl;
    Component_MFH.sngH_w = Number.isFinite(Number(Component_MFH.sngH_c))
      ? hMl - Number(Component_MFH.sngH_c)
      : -1;
    GML_module.sngtam = tam;
    LTA_module.sngtmm = tmm;
    LTA_module.sngss = sLong;
    LTA_module.sngcc = cCirc;

    const rt = tc > 0 ? (tmm - fcaMl) / tc : NaN;
    const lambdaDenominator = Number.isFinite(diameterInThicknessUnits) && Number.isFinite(tc) && diameterInThicknessUnits > 0 && tc > 0
      ? Math.sqrt(diameterInThicknessUnits * tc)
      : NaN;
    const lambdaRaw = Number.isFinite(lambdaDenominator) && lambdaDenominator > 0
      ? (1.285 * sLong) / lambdaDenominator
      : NaN;
    const lambda = Number.isFinite(lambdaRaw) ? Math.min(lambdaRaw, 20) : NaN;

    const mt1 = Number.isFinite(lambda)
      ? 1.001 -
        0.014195 * lambda +
        0.2909 * Math.pow(lambda, 2) -
        0.09642 * Math.pow(lambda, 3) +
        0.02089 * Math.pow(lambda, 4)
      : NaN;
    const mt2 = Number.isFinite(lambda)
      ? -0.003054 * Math.pow(lambda, 5) +
        2.957e-4 * Math.pow(lambda, 6) -
        1.8462e-5 * Math.pow(lambda, 7) +
        7.1553e-7 * Math.pow(lambda, 8)
      : NaN;
    const mt3 = Number.isFinite(lambda)
      ? -1.5631e-8 * Math.pow(lambda, 9) +
        1.4656e-10 * Math.pow(lambda, 10)
      : NaN;
    const mt = Number.isFinite(mt1) && Number.isFinite(mt2) && Number.isFinite(mt3)
      ? mt1 + mt2 + mt3
      : NaN;

    const rsf = Number.isFinite(rt) && Number.isFinite(mt) && mt !== 0
      ? rt / (1 - ((1 - rt) / mt))
      : NaN;

    const mfhBase = Number.isFinite(Number(Component_MFH.sngMFH)) && Number(Component_MFH.sngMFH) > 0
      ? Number(Component_MFH.sngMFH)
      : hL;
    const mfhReduced = Number.isFinite(rsf)
      ? hMl + ((Component_MFH.sngMFH_hydro - hMl) * (rsf / rsfA))
      : NaN;
    const mfhReducedValid = Number.isFinite(mfhReduced) ? Math.min(mfhReduced, mfhBase) : NaN;
    const maxFillingHeight = Number.isFinite(mfhReducedValid) ? Math.min(mfhReducedValid, hL) : NaN;

    if (this.isLmlEquationLogContext()) {
      console.log("[LML Results Eq]", {
        equation: "MFH_r = H_ml + ((MFH_hydro - H_ml) * (RSF / RSFa))",
        inputs: {
          H_ml: hMl,
          MFHHydro: Component_MFH.sngMFH_hydro,
          RSF: rsf,
          RSFa: rsfA,
        },
        results: {
          MFH_r_raw: mfhReducedValid,
          MFH_operating: maxFillingHeight,
        },
      });
    }

    const lmsdLimit = Number.isFinite(diameterInThicknessUnits) && Number.isFinite(tc) && diameterInThicknessUnits > 0 && tc > 0
      ? 1.8 * Math.sqrt(diameterInThicknessUnits * tc)
      : NaN;
    const circLimit = Number.isFinite(sLong) && Number.isFinite(eC) && Number.isFinite(eL) && eL > 0
      ? 2 * sLong * Math.sqrt(eC / eL)
      : NaN;

    const scBoxNoInfringe = (this.inspectionDataFormGroup.get("comboBox1_DI")?.value || "No") === "No";
    const rtPass = Number.isFinite(rt) && rt >= 0.2;
    const tmmPass = Number.isFinite(tmm - fcaMl) && Number((tmm - fcaMl).toFixed(3)) >= (intUnit === 0 ? 0.1 : 2.5);
    const lmsdPass = Number.isFinite(lmsd) && Number.isFinite(lmsdLimit) && lmsd >= lmsdLimit;
    const isGrooveOrGouge = isLmlMfhContext && (Component_MAWP.strD_class === "Gouge" || LTA_module.intLTA_type === 1);
    const gr = Number.isFinite(Number(LTA_module.snggr)) && Number(LTA_module.snggr) >= 0
      ? Number(LTA_module.snggr)
      : Number(this.inspectionDataFormGroup.get("textBox6_DI_snggr")?.value ?? NaN);
    const grLimit = Number.isFinite(rt) && Number.isFinite(tc)
      ? 0.5 * (1 - rt) * tc
      : NaN;
    const grPass = !isGrooveOrGouge || (Number.isFinite(gr) && Number.isFinite(grLimit) && gr >= grLimit);
    const circPass = Number.isFinite(cCirc) && Number.isFinite(circLimit) && cCirc <= circLimit;
    const hasStrongFailure = !scBoxNoInfringe || !rtPass || !tmmPass || !lmsdPass || !grPass || !circPass;

    CalcTemplate.sngRSF = rsf;
    CalcTemplate.sngMFH_r = mfhReducedValid;
    CalcTemplate.sngMFH_d = hL;
    LTA_module.sngRt = rt;
    LTA_module.sngLamda = lambda;

    const thicknessUnit = intUnit === 0 ? "inch" : "mm";
    const heightUnit = intUnit === 0 ? "ft" : "m";
    const precision = intUnit === 0 ? 3 : 2;
    const fmt = (value: number, digits: number = precision) => Number.isFinite(value) ? Number(value).toFixed(digits) : "NaN";
    const assessmentPrefix = isLmlMfhContext ? "LTA" : "General Metal Loss";

    let result = "";
   result += `${scBoxNoInfringe ? `${assessmentPrefix} meets` : `${assessmentPrefix} fails`} the 2s x 2c box interaction criterion.${scBoxNoInfringe ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;

    result += `Thickness ratio Rt = ${fmt(rt)} ${rtPass ? ">=" : "<"} 0.2${rtPass ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;
    result += `tmm - FCAml = ${fmt(tmm - fcaMl)} ${thicknessUnit} ${tmmPass ? ">=" : "<"} ${intUnit === 0 ? "0.1" : "2.5"} ${thicknessUnit}${tmmPass ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;
    result += `Lmsd = ${fmt(lmsd)} ${thicknessUnit} ${lmsdPass ? ">=" : "<"} 1.8 * sqrt(D * tc) = ${fmt(lmsdLimit)} ${thicknessUnit}${lmsdPass ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;

    if (isGrooveOrGouge) {
      const grDigits = intUnit === 0 ? 3 : 1;
      result += `gr = ${fmt(gr, grDigits)} ${thicknessUnit} ${grPass ? ">=" : "<"} 0.5 * (1 - Rt) * tc = ${fmt(grLimit, grDigits)} ${thicknessUnit}${grPass ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;
    }

    result += `RSF = ${fmt(rsf)} ${Number.isFinite(rsf) && rsf < rsfA ? "<" : ">="} RSFa = ${fmt(rsfA)}${Number.isFinite(rsf) && rsf < rsfA ? " ==> Filling height reduction may be required" : ""}<br />`;

    const mfhNeedsReduction = Number.isFinite(mfhReducedValid) && Number.isFinite(hL) && mfhReducedValid < hL;
    if (tmmPass && lmsdPass) {
        result += `MFH_r = ${fmt(mfhReducedValid, 3)} ${heightUnit} ${mfhNeedsReduction ? "<" : ">="} H_L = ${fmt(hL, 3)} ${heightUnit}${mfhNeedsReduction ? " ==> Filling height reduction may be required" : ""}<br />`;
    }

    // In case of LML Tank that C in result not needed//
    if (!isLmlMfhContext && assessmentPrefix === "LTA") {

    result += `c = ${fmt(cCirc)} ${thicknessUnit} ${circPass ? "<=" : ">"} 2 * s * sqrt(E_c / E_L) = ${fmt(circLimit)} ${thicknessUnit} ==> Circ. extent of the metal loss is ${circPass ? "acceptable" : "not acceptable"}.${circPass ? "" : " <font color=\"red\">*Fail*</font>"} <br />`;
    }

    if (hasStrongFailure) {
      result += `<br />`;
      if (isGrooveOrGouge) {
        result += `<font color="red">Groove failed the level 1 assessment<br />Consider performing a Local Metal Loss (Profile Data) or a level 3 assessment</font><br />`;
      } else if (isLmlMfhContext) {
        if( !tmmPass || !lmsdPass || !rtPass) {
          result += `<font color="red">Local Metal Loss failed the assessment. <br /> Consider performing a Level 3 assessment.</font><br />`;
        } else {
          result += `<font color="red">Local Metal Loss failed the assessment. <br /> Consider performing a Local Metal Loss (Profile Data) or Level 3 assessment.</font><br />`;
        }
      } else {
        result += `<font color="red">General Metal Loss failed the Level 1 assessment.<br />Consider performing a Local Metal Loss Profile or Level 3 Assessment.</font><br />`;
      }
    } else if (Number.isFinite(mfhReducedValid) && Number.isFinite(hL) && mfhReducedValid < hL) {
      result += `<br /><font color="orange">Equipment can only be operated at Maximum Filling Height = ${fmt(mfhReducedValid , 3)} ${heightUnit}</font><br />`;
    } else {
      result += `<br /><font color="blue">Equipment can be operated at Maximum Filling Height = ${fmt(hL, 3)} ${heightUnit}</font><br />`;
    }

    // Persist result and input snapshots only for LML/Gouge MFH flows
    if (isLmlMfhContext) {
      Component_MFH.mfhLmlCalcResult = result;
      Component_MFH.snap_tam = tam;
      Component_MFH.snap_tmm = tmm;
      Component_MFH.snap_FCAml = fcaMl;
      Component_MFH.snap_sLong = sLong;
      Component_MFH.snap_cCirc = cCirc;
      Component_MFH.snap_lmsd = lmsd;
      Component_MFH.snap_gr = isGrooveOrGouge && Number.isFinite(gr) ? gr : NaN;
    } else {
      Component_MFH.mfhGmlCalcResult = "";
      Component_MFH.mfhLmlCalcResult = "";
      Component_MFH.snap_tam = 0;
      Component_MFH.snap_tmm = 0;
      Component_MFH.snap_FCAml = 0;
      Component_MFH.snap_sLong = 0;
      Component_MFH.snap_cCirc = 0;
      Component_MFH.snap_lmsd = 0;
      Component_MFH.snap_gr = NaN;
    }

    return result;
  }


  onPressPictureBox2_DI_LTA() {
    // Check if this is LML tank shell course (MFH mode)
    if (this.isMfhMode) {
      const isLmlLta =
        Component_MAWP.strD_class === "LTA" &&
        Component_MAWP.strD_iclass === 1;

      // For MFH mode, use the MFH calculation instead of LTA
      let resultFromValidation = LTA_module.check_LTA_Data(
        this.inspectionDataFormGroup
      );
      this.validation_list = LTA_module.validationMessage;
      const isHmlValid = this.updateHmlAgainstHcValidation();
      if (!resultFromValidation || !isHmlValid) {
        return;
      }
      
      // Use the MFH selected calculation for tank shell course
      this.result = isLmlLta
        ? this.runMfhSelectedCalc()
        : LTA_module.LTA_calc();
      this.nextStep.emit();
      return;
    }

    // Non-MFH LTA path: use standard LTA calculation
    let resultFromValidation = LTA_module.check_LTA_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = LTA_module.validationMessage;
    const isHmlValid = this.updateHmlAgainstHcValidation();
    if (!resultFromValidation || !isHmlValid) {
      return;
    }

    this.result = LTA_module.LTA_calc();
    this.nextStep.emit();
  }

  onPressPictureBox2_DI_LTA_Profile() {
    if (this.isMfhMode && !this.validateMfhProfileInspectionData()) {
      return;
    }

    let resultFromValidation = LTA_module.check_LTA_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = LTA_module.validationMessage;
    if (!resultFromValidation) {
      return;
    }
    this.nextStep.emit();
  }

  private validateMfhProfileInspectionData(): boolean {
    const messages: string[] = [];
    // LTAP tanks (strD_iclass === 2) binds to the ltap_* controls in tanks-ltap-inspection-fields; other MFH classes still use the legacy textBox_* controls.
    const isLtapTanks = Component_MAWP.strD_iclass === 2;
    const hMlControlName = isLtapTanks ? "ltap_hml" : "textBox3_DI_sngH_f";
    const fcaMlControlName = isLtapTanks ? "ltap_fcaml" : "textBox2_DI";

    const hMl = Number(this.inspectionDataFormGroup.get(hMlControlName)?.value);
    const hC = Number(Component_MFH.sngH_c);
    const hL = Number(Component_MFH.sngH_L);
    const fcaMl = Number(this.inspectionDataFormGroup.get(fcaMlControlName)?.value);

    if (!Number.isFinite(fcaMl) || fcaMl < 0) {
      messages.push("Future corrosion allowance inside the damage area, FCAml - invalid value.");
    }

    if (!Number.isFinite(hMl) || hMl < 0) {
      messages.push("Distance from the lower edge of the flaw to the bottom of the tank, H_ml - invalid value.");
    } else {
      if (Number.isFinite(hC) && hMl < hC) {
        messages.push("H_ml cannot be less than H_c.");
      }
      if (Number.isFinite(hL) && hMl > hL) {
        messages.push("H_ml cannot be greater than H_L.");
      }
    }

    if (messages.length > 0) {
      this.validation_list = messages;
      return false;
    }

    return true;
  }

  onPressPictureBox2_DI_Gouge() {
    let resultFromValidation = LTA_module.check_LTA_Data(
      this.inspectionDataFormGroup
    );

    this.validation_list = LTA_module.validationMessage;
    const isHmlValid = this.updateHmlAgainstHcValidation();
    if (!resultFromValidation || !isHmlValid) {
      return;
    }

    this.result = LTA_module.LTA_calc();
    this.nextStep.emit();
  }

  // H_ml is measured from the tank floor, so it can never fall below the bottom of the
  // shell course under assessment (H_c). Local Metal Loss screens only (LTA / Gouge).
  private isHmlBelowHc(): boolean {
    if (
      !this.isTankComponent() ||
      [1, 3].indexOf(Component_MAWP.strD_iclass) === -1
    ) {
      return false;
    }

    const rawHml = this.inspectionDataFormGroup.get("textBox7_DI")?.value;
    if (rawHml === null || rawHml === undefined || `${rawHml}`.trim() === "") {
      return false;
    }

    const hMl = Number(rawHml);
    const hC = Number(Component_MFH.sngH_c);

    return Number.isFinite(hMl) && Number.isFinite(hC) && hC >= 0 && hMl < hC;
  }

  private updateHmlAgainstHcValidation(): boolean {
    const isValid = !this.isHmlBelowHc();
    const otherMessages = (this.validation_list || []).filter(
      (message) => message !== this.hmlBelowHcMessage
    );

    this.validation_list = isValid
      ? otherMessages
      : [...otherMessages, this.hmlBelowHcMessage];

    return isValid;
  }

  onPressPictureBox2_DI_Pitting() {
    this.inspectionDataCalculateCallValidationsInPitting.next(true); // call validations logic in pitting-information component
    if (this.validation_list.length != 0) return;

    if (this.pittingDisplayWarningModal) {
      this.openPittingWarningModal();
    } else {
      Pitting_module.Pit_RSF_calc();
      this.result = Pitting_module.Pit_calc();
      this.nextStep.emit();
    }
  }

  onPressPictureBox2_DI_BlisterHIC() {
    let resultFromValidation = BlisterHIC_module.check_BlisterHIC_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = BlisterHIC_module.validationMessageBlisterHIC;

    if (!resultFromValidation) {
      return;
    }

    if (Component_MAWP.strD_class == "Blister") {
      this.result = BlisterHIC_module.Blister_calc();
    } else if (Component_MAWP.strD_class == "HIC") {
      this.result = BlisterHIC_module.HIC_calc();
    }

    this.nextStep.emit();
  }

  onPressPictureBox2_DI_CrackLike() {
    let resultFromValidation = Crack_Module.check_NewCrack_Data1(
      this.inspectionDataFormGroup
    );
    this.validation_list = Crack_Module.validationMessageCrack;
    this.validation_list_ComponentInformation =
      Crack_Module.validationMessageComponentInformation;

    if (!resultFromValidation) {
      return;
    }

    //logic from Form1.cpp -> pictureBox_RA_Click
    switch (Component_MAWP.intEquip) {
      case 2: //Sphere
        Component_MAWP.intEquip = 1;
        break;
      case 5://B31.3 Piping
        Component_MAWP.intEquip = 0; // Added as new requirement and used for the graph calculations, value should be same as Cylinder - suggested by Alfonso
        Component_MAWP.sngp_H = -1;  // when user slected "B31.3 Piping" in Crack-Like Indications then Liquid  headHeight -1 should be considered
        break;
      case 6://B31.4 Piping
        Component_MAWP.intEquip = 0; // Added as new requirement and used for the graph calculations, value should be same as Cylinder - suggested by Alfonso
        Component_MAWP.sngp_H = -1;  // when user slected "B31.4 Piping" in Crack-Like Indications then Liquid  headHeight -1 should be considered
        break;
      case 7://B31.8 Piping
        Component_MAWP.intEquip = 0; // Added as new requirement and used for the graph calculations, value should be same as Cylinder - suggested by Alfonso
        Component_MAWP.sngp_H = -1;  // when user slected "B31.8 Piping" in Crack-Like Indications then Liquid  headHeight -1 should be considered
        break;
      default:
        break;
    }

    this.result = Crack_Module.Crack_calc();

    if (Crack_Module.crackAlertMessageFix.length != 0) {
      this.openCrackAlertModal();
    } else {
      this.nextStep.emit();
    }
  }

  onPressPictureBox2_DI_Dent() {
    let resultFromValidation = Dent_Module.check_Dent_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = Dent_Module.validationMessage;
    if (!resultFromValidation) {
      return;
    }
    this.result = Dent_Module.Dent_calc();
    this.nextStep.emit();
  }

  onPressPictureBox2_DI_DentGouge() {
    this.validation_list = [];
    this.validation_list_ComponentInformation = [];
    this.componentInformationValidation.next(true);
    let resultFromValidation = Dent_Module.check_Dent_Gouge_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = Dent_Module.validationMessage;
    this.validation_list_ComponentInformation = Dent_Module.validationMessageComponentInformation;

    if (!resultFromValidation) {
      return;
    }
    this.result = Dent_Module.Dent_Gouge_calc();
    this.nextStep.emit();
  }

  onPressPictureBox2_DI_Laminations() {
    if (!this.equipHydInLaminationsCorrect()) return;

    let resultFromValidation = Laminations_module.check_Laminations_Data(
      this.inspectionDataFormGroup
    );
    this.validation_list = Laminations_module.validationMessage;
    if (!resultFromValidation) {
      return;
    }
    this.result = Laminations_module.Laminations_calc();
    this.nextStep.emit();
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.inspectionDataFormGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  private openCrackAlertModal(): void {
    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: Crack_Module.crackAlertMessageFix,
        caption: "Alert",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.nextStep.emit();
    });
  }

  private openGenericErrorModal(warningMessage: string, caption: string): void {
    this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: [warningMessage],
        caption: caption,
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }
}
